import { useId } from 'react';

interface K2LogoProps {
  size?: number;
  /**
   * `plate` draws the navy rounded square only (app-bar mark).
   * `framed` adds the white ring used on the splash, where the mark sits on navy.
   */
  variant?: 'plate' | 'framed';
}

/**
 * Concept 1a · ຍອດພູ (Peak) — the chosen mark. A stylised K2 summit rising from a
 * sand/gravel base bar, with a sky notch marking the peak.
 *
 * The gradient id is still scoped with `useId`: SVG def ids are document-global
 * on the web too, so two logos at different sizes on one page would otherwise
 * share whichever gradient mounted first.
 */
export function K2Logo({ size = 34, variant = 'plate' }: K2LogoProps) {
  const framed = variant === 'framed';
  const gradientId = `k2peak-${useId()}`;

  return (
    <svg width={size} height={size} viewBox="0 0 120 120" role="img" aria-label="K2TECH">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#123f8e" />
          <stop offset="1" stopColor="#2E76D6" />
        </linearGradient>
      </defs>

      {framed ? (
        <>
          <rect x={4} y={4} width={112} height={112} rx={30} fill="#FFFFFF" />
          <rect x={10} y={10} width={100} height={100} rx={25} fill={`url(#${gradientId})`} />
          <path d="M24 84 L54 42 L71 66 Z" fill="#2E76D6" />
          <path d="M48 84 L78 38 L98 84 Z" fill="#FFFFFF" />
          <path d="M78 38 L87 60 L78 55 L69 60 Z" fill="#38BDF8" />
          <rect x={24} y={88} width={74} height={6} rx={3} fill="#38BDF8" />
        </>
      ) : (
        <>
          <rect x={4} y={4} width={112} height={112} rx={30} fill={`url(#${gradientId})`} />
          <path d="M20 86 L52 40 L70 66 Z" fill="#2E76D6" />
          <path d="M46 86 L78 34 L100 86 Z" fill="#FFFFFF" />
          <path d="M78 34 L88 58 L78 52 L68 58 Z" fill="#38BDF8" />
          <rect x={20} y={90} width={80} height={6} rx={3} fill="#38BDF8" />
        </>
      )}
    </svg>
  );
}
